import React, { useState } from "react";
import { TextField, InputAdornment } from "@material-ui/core"; // Importando corretamente o InputAdornment
import Swal from "sweetalert2";
import axios from "axios";
import InputMask from "react-input-mask"; // Importando o InputMask
import CircularProgress from "@material-ui/core/CircularProgress"; // Importando o CircularProgress

export default function TextFieldCEP(props) {
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  const handleChange = (event) => {
    if (props.onChange) {
      props.onChange(event);
    }
  };

  const getDataEndereco = () => {
    setLoading(true);
    axios
      .get("https://viacep.com.br/ws/" + props.value + "/json/")
      .then((response) => {
        if (response.status === 200) {
          props.setDataCep(response.data); // Atualiza o estado com os dados recebidos
        } else {
          props.setDataCep([]);
        }
        setTimeout(() => {
            setLoading(false);   
        }, 500);
      })
      .catch((error) => {
        Swal.fire("Erro", "Falha ao buscar dados do endereço ou CEP não encontrado", "error");
        props.setDataCep([]);
        setTimeout(() => {
            setLoading(false);   
        }, 500);
      });
  };

  return (
    <TextField
      {...props}
      type="text"
      error={error}
      onChange={handleChange}
      onKeyDown={(e) => {
        if (e.keyCode === 13) {
          // Exemplo: chamar getDataEndereco quando Enter for pressionado
          getDataEndereco();
        }
      }}
      InputProps={{
        inputComponent: InputMask,
        endAdornment: <InputAdornment position="end">
          {loading ? <CircularProgress size={20} color="secondary" /> : null }
        </InputAdornment>,
        inputProps: {
          mask: "99999-999", // Máscara para o formato de CEP
          maskChar: " ", // Caracter usado para preencher os espaços vazios
          // Exibe o CircularProgress apenas quando loading é true
        },
      }}
    />
  );
}
